import React, { useEffect, useState, useRef } from 'react';
import { Redirect, useHistory } from "react-router-dom";
import { useCoverLetter } from '../../context/CoverLetterContext';
import { COVERLETTER_FINALIZE, DASHBOARD_LINK, POPUP_TYPES, PAID_SERVICES, COOKIE_DOMAIN, MEMBERSHIP, TPLTS } from '../../constants/constants';
import '../../assets/scss/app/cover-letter-screens/letter-form.scss';
import SaveIcon from '../../assets/images/save-icon-brown.svg';
import PrintIcon from '../../assets/images/print-icon-brown.svg';
import DesignControl from './finalize/DesignControl';
import FormSection from './finalize/FormSection';
import LetterPreview from './templates/LetterPreview';
import WpAPI from '../../WpApi';
import downloadResume from '../../downloadResume';
import { usePopup } from '../../context/PopupContext';
import jsCookie from 'js-cookie';
import { useUser } from '../../context/UserContext';
import { buttonTextTransition } from '../../helper';
import { useResumePreviewSize } from '../common/useResumePreviewSize';
import StyleOptions from './finalize/StyleOptions';
import ListTemplate from './ListTemplate';

const Finalize = (props) => {
  const [width, height, scale] = useResumePreviewSize();
  const [back, setBack] = useState(false);
  const [next, setNext] = useState(false);
  const [saveButtonLabel, setSaveButtonLabel] = useState('Save');
  const popupbox = usePopup();
  const [showStylePanel, setStylePanel] = useState(false);
  const [showLeftPanel, setShowLeftPanel] = useState(true);
  const [showRightPanel, setShowRightPanel] = useState(true);
  const [showBottomCardPanel, setBottomCardPanel] = useState(false);
  const [redirect2, setRedirect2] = useState(null);
  //Show error using this state
  const [error, setError] = useState({});
  const [checkField, setCheckField] = useState('');
  const [selectedCustomColor, setSelectedCustomColor] = useState('');
  const clobj = useCoverLetter();
  const {
    from,
    to,
    summary,
    active_template,
    active_color,
    custom_template_color,
    qa_steps_initiated,
    created_date,
    handlers: {
      editInProgress,
      loadLetter,
      save
    },
  } = useCoverLetter();
  const {
    checkMembership,
    plan,
    user
  } = useUser();
  useEffect(() => {
    editInProgress() && !qa_steps_initiated && !created_date && loadLetter();
    //below function will make sure user infor loaded
    checkMembership(null, true);
  }, []);


  const removeError = (e) => {
    setError({ ...error, [e.target.name]: "" });
  }

  const fieldFocus = e => {
    setCheckField(e.target.name);
    removeError(e);
  }

  const fieldBlur = e => {
    setCheckField('');
  }

  useEffect(() => {
    next && setRedirect2(COVERLETTER_FINALIZE)
    next && clobj.handlers.save()
  }, [back, next]);

  useEffect(() => {
    //browser issue, page not opening at top
    window.scrollTo(0, 0)
    popupbox.configurePopup(POPUP_TYPES);
  }, []);
  useEffect(() => {
    if (qa_steps_initiated) {
      const ac = localStorage.getItem('clickAction');
      if (ac == 'cl_download') {
        popupbox.show('download', null, (popupParams) => {
          downloadHandler(jsCookie.get('current_letter', { domain: COOKIE_DOMAIN, path: "/" }), popupParams.downloadFormat);
          // gaTrack('RT App', 'Dashboard', `Download Cover Letter`)
          ;
        }, { plan: plan, entity: { type: 'coverletter', name: 'Cover Letter' } });
        localStorage.removeItem('clickAction')
      }
    }
  }, [qa_steps_initiated])
  useEffect(() => {
    window.innerWidth <= 1200 ? TogglePanel(true, false) : TogglePanel(true, true);
  }, []);
  const downloadHandler = (key, downloadFormat) => {
    downloadResume({
      coverletter: { from, to, summary, active_template, active_color, custom_template_color, id: key },
      user: user
    },
      user,
      () => { 
        popupbox.close('download'); 
      },
      downloadFormat,
      { type: 'coverletter', name: 'Cover Letter' });
  }

  const download = (params) => {
    localStorage.setItem(`coverletterName`, params.rname);
    popupbox.show('download', null, (popupParams) => {
      downloadHandler(params.key, popupParams.downloadFormat);
      // gaTrack('RT App', 'Dashboard', `Download Cover Letter`)
      ga4Track(`app_download_coverletter`, 'RT App', `Download Cover Letter`);
    }, { plan: plan, entity: { type: 'coverletter', name: 'Cover Letter' } });
    ga4Track(`app_my_coverletters_download`, 'RT App', `My Cover Letters: Download`);
  }

  const openPrintWindow = () => {
    // userCompletesSectionsDownloadsPrintsOrShares();
    // if (!navigator.onLine) {
    //     alert("You seem to be offline. Please try again later.");
    //     return false;
    // }else{
    if (plan == 'pro') {
      window.print();
    } else {
      history.pushState(null, COVERLETTER_FINALIZE);
      WpAPI.setRedirectCookie(location.pathname);
      setRedirect2(MEMBERSHIP)
    }

    //}
  }
  const printHandler = () => {
    // localStorage.setItem('clickAction', 'coverletter_print');
    openPrintWindow();
    const ec = (window.innerWidth < 769 ? 'app_cover_letter_print_mobile' : 'app_cover_letter_print');
    const el = (window.innerWidth < 769 ? 'Mobile Print' : 'Print');
    // gaTrack('RT App', `Quick Editor`, el);
    ga4Track(ec, 'RT App', el);
  }
  // Show/Hide Left/Right panel
  const TogglePanel = (l, r) => {
    setShowLeftPanel(l);
    setShowRightPanel(r);
    //Handle mobile to disable style in case ""Go back to Editor "" button is directly clicked
    r || setStylePanel(false);
  }
  if (!WpAPI.isLoggedIn()) return <Redirect to={DASHBOARD_LINK} />
  if (redirect2) return <Redirect to={redirect2} />

  return (
    <div className="cover-editor-panel">
      <style>
        {`
        @media(min-width:1201px) { .footer-container{position: fixed;bottom: 0;width: 100%;left: 0;right: 0;z-index: 99;}}
        @media(max-width:1200px) { .footer-container{display: none;}}`
        }
      </style>
      {plan != 'pro' &&
        <style>
          {`@media print { .panel-cover-preview{display: none;}}`}
        </style>
      }
      <div className="panel-container">
        {showLeftPanel && <div className='no-print'>
          {showStylePanel ? <DesignControl setStylePanel={(s) => setStylePanel(s)}  /> : <FormSection />}
        </div>}
        {showRightPanel &&
          <div className="panel-right ">
            {/* <div className="mobile-back-to-editor no-print">
              Go back to Editor <i className="arrow-bar-down"></i>
            </div> */}
            <div className={!showStylePanel ? ' customize-panel-in-mobile no-print' : 'customize-panel-in-mobile open no-print'}>
              <div className="cust-panel-ctrl-mb">
                <span className="cust-arrow" onClick={() => setStylePanel(true)}>Customization <i className="icon-right-arrow"></i></span>
                {showStylePanel && <span className="cust-close" onClick={() => setStylePanel(false)} ><i className='icon-cross-icon'></i></span>}
              </div>
              {showStylePanel && <StyleOptions setSelectedCustomColor={setSelectedCustomColor} />}
            </div>
            <div className="panel-cover-preview" id="preview-resume">
              <LetterPreview data={{ ...clobj }} scale={scale} />
            </div>
            <div className="panel-right-controls no-print">
              <div className="ctrl-left">
                <button className="round-btn design-tmp-btn" onClick={() => setStylePanel(true)} >
                  <i className="r-btn-icon icon-grid"></i><span>Templates</span>
                </button>
                <button className="round-btn" onClick={(e) => { save(); buttonTextTransition('Save', "Saved", setSaveButtonLabel) }} >
                  <i className="r-btn-icon"><SaveIcon /></i><span>{saveButtonLabel}</span>
                </button>
              </div>
              <div className="ctrl-right">
                <button className="round-btn" onClick={printHandler}><i className="r-btn-icon"><PrintIcon /></i><span>Print</span></button>
                {/* <button className="round-btn"><i className="r-btn-icon"><PreviewIcon /></i><span>Email</span></button> */}
                <button className="round-btn btn-download active"
                  onClick={() => {
                    save(); //in case something is not saved in db
                    download({
                      coverletter: { from, to, summary, active_template, active_color, custom_template_color },
                      key: jsCookie.get('current_letter', { domain: COOKIE_DOMAIN, path: "/" }),
                      rname: 'letter'
                    });
                    WpAPI.setRedirectCookie(location.pathname);
                  }}
                ><i className="r-btn-icon icon-download-2"></i><span>Download </span><i className="r-btn-icon icon-chevron-left"></i></button>
              </div>
            </div>
            <div className={!showBottomCardPanel ? "mb-bottom-card-panel no-print mb-open" : "mb-bottom-card-panel no-print"}>
              <div
                className="open-customize-panel-mb"
                onClick={() => {setBottomCardPanel(!showBottomCardPanel)
                  setSelectedCustomColor('')
                }}
              >
                <i className={!showBottomCardPanel ? 'icon-double-arrow-right top' : 'icon-double-arrow-right'}></i>
              </div>
              {showBottomCardPanel && <>
                {window.innerWidth <= 1200 ?
                  <div className="cover-template-cards right-bottom">
                    <div className="cover-cards">
                      <ListTemplate
                        templates={TPLTS
                          .filter(t => t.hasOwnProperty('coverletter') && t.coverletter)
                          .sort((a, b) => (b?.coverletter_listing_priority - a.coverletter_listing_priority))}
                        active_template={active_template}
                        //color={color}
                        customColor={selectedCustomColor}
                        // headerColor={''}
                        // page={"choose-template"}
                        // rows={2}
                        // singleResume={singleResume}
                        setSingleResume={(e) => {
                          getStaticTemplate(e);
                        }}
                      />
                    </div>
                  </div> : ""}</>}
            </div>
          </div>}

      </div>
      {window.innerWidth <= 1200 ?
        <div className="mb-container no-print">
          <div className={!showRightPanel ? 'mobile-preview-action-wrap' : 'mobile-preview-action-wrap go-to-editor'}>
            <div
              className="mobile-preview-action"
              onClick={() => {
                window.scrollTo(0, 0)
                TogglePanel(!showLeftPanel, !showRightPanel)}}
            >
              {!showRightPanel ? 'Preview Cover Letter' : "Go Back to Editor"}  <i className="arrow-bar-up"></i>
            </div>
          </div>
        </div> : ""}
    </div>
  );
}

export default Finalize;